import React, { useState, useEffect } from 'react';
import { Paper, TextField, Button, Typography, Box, Alert } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';

import { ReactComponent as Logo } from '../assets/logo_aut.svg';

export default function Login() {
  const { login, isAuth, logoutMessage, clearLogoutMessage } = useAuth();
  const [adm_login, setLogin] = useState('');
  const [pasw_senha, setSenha] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  // redireciona se já está logado
  if (isAuth) {
    return <Navigate to="/gerar" replace />;
  }

  // limpa a mensagem de sessão expirada automaticamente após 5s
  useEffect(() => {
    if (!logoutMessage) return;
    const t = setTimeout(() => clearLogoutMessage(), 5000);
    return () => clearTimeout(t);
  }, [logoutMessage, clearLogoutMessage]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(adm_login, pasw_senha);
      // em caso de sucesso, login() normalmente navega pra /gerar
    } catch (err) {
      const msg = err?.response?.data?.message || 'Falha no login';
      setError(msg);
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '100vh', p: 2 }}>
      <Paper elevation={3} sx={{ p: 4, width: '100%', maxWidth: 420 }}>
        <Typography
          variant="h5"
          gutterBottom
          fontWeight={700}
          sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        >
          <Logo style={{ height: 100, width: 'auto', display: 'block', color: '#fff' }} />
        </Typography>

        {/* Mensagem de sessão expirada (warning) vinda do contexto */}
        {logoutMessage && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            {logoutMessage}
          </Alert>
        )}

        {/* Erro de login comum */}
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <Box component="form" onSubmit={onSubmit} noValidate>
          <TextField
            label="Usuário"
            value={adm_login}
            onChange={(e) => setLogin(e.target.value)}
            fullWidth
            margin="normal"
            required
            autoComplete="username"
          />
          <TextField
            label="Senha"
            type="password"
            value={pasw_senha}
            onChange={(e) => setSenha(e.target.value)}
            fullWidth
            margin="normal"
            required
            autoComplete="current-password"
          />
          <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }} disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar'}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
